import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import QuizFlow1 from '../components/quiz/flow1/QuizFlow1'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors } from '@components/shared'
import TopNav from '@components/TopNav'
import { BannerText, TopBanner } from '@components/quiz/quizStyles'
import ConversionPaywallModal from '@components/subscribe/ConversionPaywallModal'
import { ANNUAL_PRICE_STRING } from '../helpers/subscriptionHelpers'

type PropsType = {
  bannerText: string,
  showBanner: boolean
}

type DispatchPropsType = {}

function TropeQuiz (props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <>
      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <HtmlHead
        title={`Dipsea | Sexy Audio Stories With Themes You'll Love`}
        description={'Take the quiz and unlock unlimited access to hundreds of sexy audio stories, sleep scenes, and wellness sessions. Answer a few questions and start listening.'}
      />
      <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true} isMarketingNav={true} />
      <ConversionPaywallModal
        subtype={'annual'}
        defaultSignIn={true}
        subscriptionOfferCta={'TRY 7 DAYS FREE'}
        subscriptionOfferTitle={'7 Day Free Trial'}
        subscriptionOfferSubtitle={`Annual subscription of ${ANNUAL_PRICE_STRING} USD billed at trial end`}
        subscriptionOfferSubtext={`Your card will be charged a sum of ${ANNUAL_PRICE_STRING} USD in one week for the first year of unlimited access to Dipsea. You must cancel your subscription before the end of your free trial if you do not want to be charged. Your annual subscription will auto-renew for ${ANNUAL_PRICE_STRING} USD in exactly one year and each year thereafter until you cancel.`}
        existingPromoCode='trope-quiz-week-free'
      />
      <QuizFlow1 quizType='trope-quiz'/>
      {props.showBanner && (
        <TopBanner>
          <BannerText>{props.bannerText}</BannerText>
        </TopBanner>
      )}
    </>
  )
}

const mapStateToProps = (state: AppStateType): { bannerText: any, showBanner: any } => {
  return {
    bannerText: 'One step closer to unlimited sexy stories!',
    showBanner: !!(state.promoFlowModalOpen)
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TropeQuiz) as any) as any
